module.exports = __webpack_public_path__ + "static/media/spark_logo.b1ae6478.png";